import React, { useEffect } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { Button } from '../../../Atoms/Button';
import { MarktechModal } from '../../../Atoms/Modal';
import { RECAPTCHA_SITE_KEY } from '../../../Common/ContactSalesForm/constants';
import { useContactUsForm } from './useContactus';
import { handleTrack } from '../../../../utils/tracker';

interface ContactUsModalProps {
  open: boolean;
  onClose: () => void;
  pocName?: string;
  pocPhone?: string;
  pocEmail?: string;
}

export const ContactUsModal: React.FC<ContactUsModalProps> = ({
  open,
  onClose,
}) => {
  const {
    formData,
    errors,
    formStatus,
    recaptchaRef,
    handleChange,
    handleSubmit,
    resetForm,
  } = useContactUsForm();

  useEffect(() => {
    if (!open) {
      resetForm();
    }
  }, [open, resetForm]);
  useEffect(() => {
    if (formStatus.success) {
      handleTrack({
        label: 'contact_us_success',
        valueObj: {
          email: formData.email,
          phoneNumber: formData.phoneNumber,
        },
      });
    }
  }, [formStatus.success]);
  return (
    <MarktechModal
      open={open}
      onClose={() => {
        handleTrack({
          label: 'contact_us_modal_close',
        });
        onClose();
      }}
      closeIcon="x"
      classNames={{
        modal: 'rounded-lg mobile-search-box mobile-bottom-fixed',
        closeButton: 'text-s-24',
      }}
      center
    >
      <div className="flex items-center bg-blue-50 py-6 px-8">
        <div className="font-bold text-s-24">Need Help</div>
      </div>

      <ReCAPTCHA
        sitekey={RECAPTCHA_SITE_KEY.commonLead}
        size="invisible"
        ref={recaptchaRef}
      />

      {!formStatus.success ? (
        <>
          <div className="flex gap-4 p-8">
            <div className="flex-1">
              <label
                htmlFor="contact-email"
                className="block text-sm font-medium text-font-500 mb-2"
              >
                Email
              </label>
              <input
                id="contact-email"
                type="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange('email')}
                className={`w-full rounded border px-4 py-2 focus:outline-none focus:ring-2 ${
                  errors.email
                    ? 'border-red-500 focus:ring-red-400'
                    : 'border-gray-300 focus:ring-blue-300'
                }`}
              />
              {errors.email && (
                <p className="text-red-500 text-s-14 mt-1">{errors.email}</p>
              )}
            </div>
            <div className="flex-1">
              <label
                htmlFor="contact-number"
                className="block text-sm font-medium text-font-500 mb-2"
              >
                Number
              </label>
              <input
                id="contact-number"
                type="tel"
                placeholder="Enter your phone number"
                value={formData.phoneNumber}
                onChange={handleChange('phoneNumber')}
                className={`w-full rounded border px-4 py-2 focus:outline-none focus:ring-2 ${
                  errors.phoneNumber
                    ? 'border-red-500 focus:ring-red-400 '
                    : 'border-gray-300 focus:ring-blue-300'
                }`}
              />
              {errors.phoneNumber && (
                <p className="text-red-500 text-s-14 mt-1 ">
                  {errors.phoneNumber}
                </p>
              )}
            </div>
          </div>
          {formStatus.error && (
            <p className="text-red-500 text-s-14 text-center mb-2 ">
              {formStatus.error}
            </p>
          )}
          <div className="flex justify-end px-8 pb-6">
            <Button
              type="button"
              className={`rounded bg-blue-600 px-6 py-2 font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 ${
                formStatus.loading ? 'opacity-50 cursor-not-allowed' : ''
              }`}
              onClick={handleSubmit}
              disabled={formStatus.loading}
            >
              {formStatus.loading ? 'Please wait...' : 'Request a callback'}
            </Button>
          </div>
        </>
      ) : (
        <div className="p-8 text-center">
          <h2 className="text-2xl font-bold mb-4 text-green-600">Thank You!</h2>
          <p className="text-base mb-4">
            Our representative will get in touch with you shortly.
          </p>
          <Button
            onClick={() => {
              handleTrack({
                label: 'contact_us_modal_thankyou_close',
              });
              onClose();
            }}
            className="bg-blue-600 hover:bg-blue-700 text-white rounded px-6 py-2"
          >
            Close
          </Button>
        </div>
      )}
    </MarktechModal>
  );
};
